<template>
  <action-dispatcher action="product/getProduct" :parameters="$route.params.id">
    <page-header>
      <template #custom-header>
        <div class="d-flex flex-column flex-lg-row justify-content-between">
          <product-dropdown :product="product" :dropdown="false" />
          <action-dispatcher
            small
            action="membersSetup/get"
            :parameters="$route.params.id"
            v-if="product.is_blitz_members"
          >
            <a
              :href="membersURL"
              target="_blank"
              class="members-link d-none d-lg-inline"
            >
              Acessar área de membros
              <i class="fa fa-arrow-up-right-from-square ml-2" />
            </a>
          </action-dispatcher>
        </div>
      </template>
    </page-header>
    <page-container class="view-product-edit-pixel">
      <bp-header
        class="mb-7"
        title="Pixel de rastreamento"
        subtitle="Monitore o comportamento dos seus compradores e anúncios."
      />
      <div class="boxes my-6">
        <div v-for="box in boxes" :key="box.type" class="box">
          <button class="btn" @click="newPixel(box.type)">
            <img :src="box.img" :alt="box.name" :style="box.style" />
            <span>{{ box.name }}</span>
          </button>
        </div>
      </div>

      <div class="justify-content-between pt-6">
        <bp-table-header
          v-if="pixelList.length || (!pixelList.length && search_text)"
          :total="pixelList.length"
          @refresh="refresh"
        >
          <template v-slot:buttons>
            <bp-input
              v-model="search_text"
              size="md"
              placeholder="Buscar pela descrição"
              preIcon="fa-light fa-search"
              :delay="300"
            />
          </template>
        </bp-table-header>
      </div>

      <div v-if="loading" class="text-center">
        <b-spinner variant="primary" />
      </div>

      <div v-else>
        <bp-data-table
          class="my-3"
          :data="pixelList"
          :columns="columns"
          :noMessage="!pixelList.length && search_text"
        />
        <div
          class="row justify-content-center mt-5"
          v-if="!pixelList.length && search_text"
        >
          <div class="d-flex flex-column">
            <span class="text-neutral-700 fs-16">
              Sua busca não retornou nenhum resultado!
            </span>
          </div>
        </div>
        <div
          class="row justify-content-center mt-5"
          v-else-if="!pixelList.length"
        >
          <div class="d-flex flex-column">
            <span class="fs-14">
              Você ainda não possui nenhum pixel de rastreamento cadastrado.
            </span>
          </div>
        </div>
      </div>
      <pixel-modal
        v-if="product && product.pixel"
        v-model="modal"
        :isLoading="loading"
        :type="pixelType"
        :pixel="editedPixel"
        :customConversionLabel="pixelType === 'google_ads'"
        @submit="submitPixel"
        @submitEdit="submitEditPixel"
      />
    </page-container>
  </action-dispatcher>
</template>

<script>
import ProductDropdown from "@/components/product/ProductDropdown";
import PixelModal from "@/components/product/pixel/PixelModal.vue";
import MemberAreaMixin from "@/mixins/memberArea";
import PixelMixin from "@/mixins/pixel";
import ProductActionsMixin from "@/mixins/productActions.js";

export default {
  mixins: [ProductActionsMixin, MemberAreaMixin, PixelMixin],
  components: { PixelModal, ProductDropdown },
  data() {
    return {
      pixelType: "",
      boxes: [
        {
          name: "Facebook",
          img: require("@/assets/images/fb_icon.svg"),
          type: "facebook"
        },
        {
          name: "Google Ads",
          img: require("@/assets/images/google_ads_icon.svg"),
          type: "google_ads"
        },
        {
          name: "Google Analytics",
          img: require("@/assets/images/google_analytics_icon.svg"),
          type: "google_analytics"
        },
        {
          name: "Kwai",
          img: require("@/assets/images/kwai_icon.png"),
          type: "kwai",
          style: { padding: "10px" }
        }
      ]
    };
  },
  computed: {
    pixelList() {
      let list = [];

      if (this.product && this.product.pixel) {
        list = this.product.pixel;
      }

      if (this.search_text) {
        list = list.filter(p =>
          JSON.stringify(p)
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .match(this.search_text)
        );
      }

      return [...list.map((item, index) => ({ ...item, index }))];
    },
    columns() {
      return [
        {
          name: "Ferramenta",
          field: "type"
        },
        {
          name: "Pixel",
          field: "code"
        },
        {
          name: "Label de conversão",
          field: "conversion_label"
        },
        {
          name: "",
          type: "menu",
          options: [
            {
              label: "Editar",
              icon: "fa-light fa-pen",
              click: i => this.editPixel(i)
            },
            {
              label: "Excluir pixel",
              class: "text-negative-600",
              icon: "fa-light fa-trash",
              click: i => this.submitRemovePixel(i)
            }
          ]
        }
      ];
    }
  },
  mounted() {
    this.getMemberAreaSetup();
  },
  methods: {
    pixelTypeName(t) {
      const types = {
        facebook: "Facebook",
        google_ads: "Google Ads",
        google_analytics: "Google Analytics",
        kwai: "Kwai"
      };
      return types[t];
    }
  }
};
</script>
<style lang="scss" scoped>
.view-product-edit-pixel {
  .boxes {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 12px;
    @media screen and (max-width: 767px) {
      display: flex;
      flex-direction: column;
    }
    .box {
      border-radius: 4px;
      border: 1px solid #d7d7d7;
      background: rgba(255, 255, 255, 0.32);
      backdrop-filter: blur(12px);
      transition: 0.2s all;
      button.btn {
        width: 100%;
        img {
          width: 50px;
          height: 50px;
        }
      }
      &:hover {
        border: 1px solid var(--Semantic-Neutral-076, rgba(215, 215, 215, 0.76));
        background: var(--Surface-Cumulative-plus8, rgba(255, 255, 255, 0.32));
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);
      }
    }
  }
}
</style>
